<template>
	<div class="OrderStats">
		<common-body aside="8">
			<div slot="commonMain" class="offer_box">
				<el-row type="flex" align="middle" class="offer_header">
					<el-row type="flex" align="middle" class="search_box">
						<el-input class="search_input" placeholder="单号/联系人/电话" v-model="search" clearable
							@input="scheduleSearch" @clear="searchNow" @keyup.enter.native="searchNow"></el-input>
						<el-row type="flex" align="middle" justify="center" class="search_img" @click.native="searchNow">
							<img src="../assets/img/search.png" />
						</el-row>
					</el-row>
					<el-date-picker class="header_date" value-format="timestamp" :editable="editable" @change="getDate"
						v-model="dateTime" type="daterange" range-separator="-" start-placeholder="起始日期"
						end-placeholder="结束日期">
					</el-date-picker>
					<el-select class="header_select" v-model="payStatus" clearable placeholder="付款状态" @change="searchNow">
						<el-option label="未付款" value="1"></el-option>
						<el-option label="已付款" value="2"></el-option>
						<el-option label="售后补单" value="3"></el-option>
					</el-select>
					<el-select class="header_select" v-model="orderStatus" clearable placeholder="发货状态" @change="searchNow">
						<el-option label="未发货" value="1"></el-option>
						<el-option label="已发货" value="2"></el-option>
					</el-select>
					<div @click="delSearch" class="header_btn">清空</div>
				</el-row>
				<div v-if="categoryName" class="lq-category-hint">当前分类：{{ categoryName }}</div>
				<el-row type="flex" align="middle" class="stats_summary">
					<div class="stats_item">订单数：<span>{{summary.total || 0}}</span></div>
					<div class="stats_item">合同总额：<span>{{summary.total_amount || 0}}</span></div>
					<div class="stats_item">已付款：<span>{{summary.paid_count || 0}}</span></div>
					<div class="stats_item">未付款：<span>{{summary.unpaid_count || 0}}</span></div>
				</el-row>
				<el-table :data="list" class="lq-table lq-table--clickable" style="width: 100%" cell-class-name="good_text"
					header-cell-class-name="good_header" @row-dblclick="handleRowDblClick">
					<el-table-column align="center" min-width="4%" label="序号" class-name="is-num">
						<template slot-scope="scope">
							<div>{{scope.$index+1}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="10%" prop="order_number" label="单号" class-name="is-num">
						<template slot-scope="scope">
							<div>{{ scope.row.order_number }}</div>
							<div v-if="scope.row.sample_deduct_text" class="sample-deduct-tag">{{ scope.row.sample_deduct_text }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="10%" prop="customer_id" label="往来单位">
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="contacts" label="联系人">
					</el-table-column>
					<el-table-column align="center" min-width="10%" prop="contacts_phone" label="联系电话">
					</el-table-column>
					<el-table-column align="center" min-width="10%" prop="total" label="合同金额" class-name="is-amount">
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="user_name" label="制单人">
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="createTime" label="录入日期">
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="pay_status_text" label="付款状态">
						<template slot-scope="scope">
							<div :class="'good_pay'+scope.row.pay_status">{{scope.row.pay_status_text}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="status_text" label="发货状态">
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="remarks" label="备注">
						<template slot-scope="scope">
							<div>{{scope.row.remarks&&scope.row.remarks!=""?scope.row.remarks:"无"}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" width="80" label="操作" class-name="lq-action-col" header-align="center">
						<template slot-scope="scope">
							<el-tooltip v-if="canSee" content="查看详情" placement="top">
								<el-button type="text" icon="el-icon-view" class="lq-row-action-btn" @click="showDetail(scope.$index)" />
							</el-tooltip>
							<span v-else>无</span>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="good_page" :hide-on-single-page="pageSingle" @current-change="changePage"
					:page-size="limit" prev-text="上一页" next-text="下一页" background layout="prev, pager, next"
					:total="listTotal">
				</el-pagination>
			</div>
		</common-body>
	</div>
</template>

<script>
	import {
		getT
	} from "../assets/js/public.js"
	import {
		fetchQuotationCategory
	} from "../utils/quotation-category.js"
	export default {
		name: 'OrderStats',
		data() {
			return {
				categoryId: 0,
				categoryName: '',
				categoryWarned: !1,
				ruleList: JSON.parse(localStorage.getItem('ruleList')),
				editable: !1,
				search: '',
				payStatus: '',
				orderStatus: '',
				page: 1,
				pageSingle: !1,
				limit: 10,
				listTotal: 0,
				list: [],
				summary: {},
				dateTime: '',
				stime: '',
				etime: '',
				searchTimer: null
			}
		},
		computed: {
			canSee() {
				return !!this.ruleList.order_stats_see
			}
		},
		beforeRouteEnter(to, from, next) {
			if (from.name == 'OfferDetail' || from.name == 'DeliveryDetail') {
				next(vm => {
					vm.reload()
				})
			} else {
				next();
			}
		},
		beforeRouteLeave(to, from, next) {
			from.meta.keepAlive = !1
			next()
		},
		created() {
			this.reload();
		},
		beforeDestroy() {
			if (this.searchTimer) clearTimeout(this.searchTimer)
		},
		methods: {
			reload() {
				let that = this
				fetchQuotationCategory(that.$fetch.bind(that)).then(function(info) {
					that.categoryId = info.categoryId
					that.categoryName = info.categoryName || ''
					that.page = 1
					that.getList()
				})
			},
			getList() {
				let that = this
				if (!that.categoryId) {
					that.list = []
					that.listTotal = 0
					that.summary = {}
					if (!that.categoryWarned) {
						that.categoryWarned = !0
						that.$message({
							message: '请先在产品列表选择产品分类',
							center: !0,
							type: 'warning',
							duration: 1500
						})
					}
					return
				}
				that.$fetch('addons/hlm/api.Order/orderStatsList', {
					page: that.page,
					limit: that.limit,
					search: that.search,
					type: that.categoryId,
					pay_status: that.payStatus,
					order_status: that.orderStatus,
					stime: that.stime,
					etime: that.etime
				}).then(function(res) {
					if (res.code == 1) {
						let list = res.data.list || []
						list.forEach((item) => {
							item.createTime = getT(item.createtime * 1000)
						})
						that.list = list
						that.listTotal = res.data.total
						that.summary = res.data.summary || {}
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getDate(e) {
				let that = this
				if (!e || !e.length) {
					that.stime = '', that.etime = ''
				} else {
					that.stime = e[0] / 1000, that.etime = e[1] / 1000
					if (e[1] / 1000 < e[0] / 1000) that.stime = e[1] / 1000, that.etime = e[0] / 1000
				}
				that.searchNow()
			},
			changePage(e) {
				this.page = e, this.getList()
			},
			scheduleSearch() {
				let that = this
				if (that.searchTimer) clearTimeout(that.searchTimer)
				that.searchTimer = setTimeout(function() {
					that.searchTimer = null
					that.searchList()
				}, 300)
			},
			searchNow() {
				if (this.searchTimer) {
					clearTimeout(this.searchTimer)
					this.searchTimer = null
				}
				this.searchList()
			},
			searchList() {
				this.page = 1, this.getList()
			},
			delSearch() {
				if (this.searchTimer) {
					clearTimeout(this.searchTimer)
					this.searchTimer = null
				}
				this.search = "", this.dateTime = "", this.etime = "", this.stime = "",
					this.payStatus = "", this.orderStatus = ""
				this.searchList()
			},
			showDetail(e) {
				let row = this.list[e]
				if (String(row.pay_status) === '2') {
					this.$router.push(`/deliveryDetail?id=${row.id}`)
				} else {
					this.$router.push(`/offerDetail?id=${row.id}`)
				}
			},
			handleRowDblClick(row) {
				if (!this.ruleList.order_stats_see) return
				const index = this.list.findIndex((item) => item.id === row.id)
				if (index >= 0) this.showDetail(index)
			},
		}
	};
</script>

<style src='../assets/css/offer.css'>
</style>
<style>
.OrderStats .header_select {
	width: 130px;
	margin-right: 12px;
}
.OrderStats .stats_summary {
	height: 56px;
	padding: 0 10px;
	border-bottom: 1px solid #D9D9D9;
}
.OrderStats .stats_item {
	font-size: 14px;
	color: #666;
	margin-right: 28px;
}
.OrderStats .stats_item span {
	color: #45B299;
	font-weight: bold;
	font-size: 16px;
}
.OrderStats .search_img {
	cursor: pointer;
}
.OrderStats .lq-category-hint {
	padding: 8px 16px 0;
	font-size: 13px;
	color: #6b7280;
	line-height: 1.4;
}
</style>
